var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24.6667,
    cy: 24.3193,
    r: 23.5,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 29.25V32.75C14.5 33.2141 14.6844 33.6592 15.0126 33.9874C15.3408 34.3156 15.7859 34.5 16.25 34.5H19.75M30.25 34.5H33.75C34.2141 34.5 34.6592 34.3156 34.9874 33.9874C35.3156 33.6592 35.5 33.2141 35.5 32.75V29.25M35.5 18.75V15.25C35.5 14.7859 35.3156 14.3408 34.9874 14.0126C34.6592 13.6844 34.2141 13.5 33.75 13.5H30.25M14.5 18.75V15.25C14.5 14.7859 14.6844 14.3408 15.0126 14.0126C15.3408 13.6844 15.7859 13.5 16.25 13.5H19.75",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8333 24.0004L25 29.8337L19.1667 24.0004C18.5833 23.417 18.2917 22.2504 19.1667 21.0837C20.0417 19.917 21.7917 19.917 22.6667 20.5004C23.5417 21.0837 23.8333 21.667 25 21.667C26.1667 21.667 26.4583 21.0837 27.3333 20.5004C28.2083 19.917 29.9583 19.917 30.8333 21.0837C31.7083 22.2504 31.4167 23.417 30.8333 24.0004Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.86ffb1a23fe372ac1ce59278fe5793c8.svg";
export { ForwardRef as ReactComponent };